import { REVIEWS_REDIRECT_MAP } from '../modules/reviews/constants/reviews';

export default {
  devLinks: 'DEV_LINKS',
};

export const ALT_IMAGE_ORIENTATION = {
  horizontal: 'HORIZONTAL',
  vertical: 'VERTICAL',
};

// NOTE: This flag will give false positives for home products with images that have taller than square aspect ratios (e.g. bathrobes)
export const CATEGORIES = {
  HOME: '3865',
};

export const FREE_SHIPPING_LINK =
  '/m/campaign/free-shipping/free-shipping-everyday?LinkType=Homepage&cm_re=2.2.16.1--HOMEPAGE_INCLUDE_1--CATEGORY%20-%205125%20-%20:details';

export const REDIRECT_MAP = {
  back: '/',
  signIn: '/account/signin',
  loyaltySignIn: '/account/signin', // As for now, loyalty sign in the same as sign in
  bag: '/my/bag',
  ...REVIEWS_REDIRECT_MAP,
};

export const STRING_SHORT_ANSWERS = {
  YES: 'Yes',
  NO: 'No',
};

export const BOOLEAN_SHORT_ANSWERS = {
  [STRING_SHORT_ANSWERS.YES]: true,
  [STRING_SHORT_ANSWERS.NO]: false,
};

export const DELIVERY_DAYS_BY_TIER = {
  TIER3_OR_DEFAULT_1P_MCOM: '3:5',
  TIER3_OR_DEFAULT_1P_BCOM: '3:6',
  TIERNA_OR_DEFAULT: '3:6',
  TIER4_VDF_MKP: '5:8',
};

export const DEFAULT_DELIVERY_MESSAGES = {
  EXT: 'Usually ships within 2 business days',
  DROP: 'Usually ships within 3 business days',
  '1P_MCOM': 'Expected to arrive in 3–5 business days',
  '1P_BCOM': 'Expected to arrive in 3–6 business days',
};

export const AI_WATERMARK_CONFIG = {
  // Desktop standard
  square: { posN: '-.435,.47', sizeN: '.0825,1' },
  default: { posN: '-.435,.48', sizeN: '.0825,1' },
  bcomDefault: { posN: '-.442,.48', sizeN: '.0825,1' },
  // Members of master
  memberOfMaster: { posN: '-.360,.45', sizeN: '.2,1' },
  // Collection members
  collectionCompact: { posN: '-.157,.34', sizeN: '.5,1' },
  collectionDesktop: { posN: '-.360,.45', sizeN: '.2,1' },
  //Collection gallery desktop
  collectionGalleryDesktop: { posN: '-.42,.461', sizeN: '.11,1' },
  collectionGalleryDesktopCut: { posN: '-.42,.469', sizeN: '.11,1' },
  collectionGalleryDesktopMcom: { posN: '-.42,.378', sizeN: '.11,1' },
  //Collection gallery mobile
  collectionGalleryMobile: { posN: '-.360,.43', sizeN: '.2,1' },
  collectionGalleryMobileMcom: { posN: '-.360,.35', sizeN: '.2,1' },
  collectionGalleryMobileCut: { posN: '-.360,.45', sizeN: '.2,1' },
  // Mobile standard
  mobileBcom: { posN: '-.37,.455', sizeN: '.2,1' },
  mobileBcomSquare: { posN: '-.37,.447', sizeN: '.2,1' },
  mobileMcom: { posN: '-.36,.455', sizeN: '.2,1' },
  // Overlay
  overlaySquare: { posN: '-.439,.47', sizeN: '.0825,1' },
  overlay: { posN: '-.447,.48', sizeN: '.0825,1' },
};
